export default {"src":"/_next/static/media/campaign_nofill.9e8487bc.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};